import { Typographies } from '@/theme';
import { Typography, styled } from '@mui/material';

export const TitleStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
}));

interface TextStyledProps {
  bold: boolean;
}

export const TextStyled = styled(Typography)<TextStyledProps>(
  ({ theme, bold }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: bold
      ? Typographies.FONT_WEIGHT_H2
      : Typographies.FONT_WEIGHT_BODY,
  }),
);
